import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  NavController,
  LoadingController,
  AlertController,
  MenuController,
  ModalController,
} from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';

import * as Moment from 'moment';
import Calendars from 'datebook/src/utils/calendars.js';

import { Constants } from '../../models/constants';
import {
  CountdownTimer,
  CountdownTimerDelegate,
} from '../../models/countdown-timer';
import { PublicEventInfo } from '../../models/public-event-info';
import {
  EventServiceOffering,
  PublicEventTimeslot,
} from '../../models/public-event-info';

import { EventReceiptPage } from '../event-receipt/event-receipt.page';

import { UserService } from '../../services/user-service';
import { Util } from '../../services/util';
import { Alert } from '../../services/alert';
import { AnalyticsService } from '../../services/analytics-service';
import { PaymentService } from '../../services/payment-service';
import { EventService } from '../../services/event-service';
import { MetaTagService } from '../../services/meta-tag-service';
import { ObservableService } from 'src/app/services/observable-service';

declare var Stripe: any;
declare var fbq: any;

@Component({
  selector: 'app-confirm-event',
  templateUrl: './confirm-event.page.html',
  styleUrls: ['./confirm-event.page.scss'],
})
export class ConfirmEventPage implements OnInit, CountdownTimerDelegate {
  cardFields: {
    cardholderName?: string;
  } = {};

  fields: {
    promoCode?: string;
  } = {};

  stripe: any;
  card: any;

  timer: CountdownTimer;
  preventRejectOnLeave: boolean = false;

  barber: any;
  expiryDate: Date;
  eventInfo?: PublicEventInfo;
  eventSelectedService?: EventServiceOffering;
  eventSelectedTimeslot?: PublicEventTimeslot;

  cost?: any;

  selectedCustomer?: any;

  paymentPickerOpen = false;
  addingNewPayment = false;
  confirming = false;
  confirmed = false;

  // UI Params
  apptAddressString: string = '';
  isCustomAddress = false;
  showAddUnitButton = false;

  promoCode?: string;

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private alert: Alert,
    private observables: ObservableService,
    private alertCtrl: AlertController,
    private analytics: AnalyticsService,
    private router: Router,
    private changeRef: ChangeDetectorRef,
    private menuCtrl: MenuController,
    private paymentService: PaymentService,
    public userService: UserService,
    private route: ActivatedRoute,
    private eventService: EventService,
    private metaTagService: MetaTagService,
  ) {
    if (Constants.DEV_MODE) {
      this.stripe = Stripe(Constants.DEV_STRIPE_KEY);
    } else {
      this.stripe = Stripe(Constants.STRIPE_KEY);
    }
  }

  ngOnInit() {
    if (
      this.router.getCurrentNavigation() &&
      this.router.getCurrentNavigation().extras.state
    ) {
      // We came from nav push. Load in initial props.
      const { state: navState } = this.router.getCurrentNavigation().extras;
      if (navState) {
        this.barber = navState.barber;
        this.expiryDate = navState.expiryDate;
        this.eventInfo = navState.eventInfo;
        this.eventSelectedService = navState.eventSelectedService;
        this.eventSelectedTimeslot = navState.eventSelectedTimeslot;
        this.calculateCost();
      }
    } else {
      let mobileEventCode = this.route.snapshot.paramMap.get('mobileEventCode');

      this.alert.show(
        'Order Canceled',
        'Your booking has expired. Please try again.',
      );
      this.eventService.rejectEventTimeslot();
      this.navCtrl.navigateBack(`/event/${mobileEventCode}`);
      return;
    }
  }

  ngAfterViewInit() {
    this.observables.publishMinimizeAllChats();

    this.selectedCustomer = this.userService.user.customer;

    // this.analytics.track(AnalyticsService.ViewedConfirmEventBooking)
    // this.analytics.track(AnalyticsService.ViewRequestEventConfirm)

    if (this.expiryDate) {
      const expiryTime = CountdownTimer.getTimerMinSec(this.expiryDate);
      this.timer = new CountdownTimer(expiryTime.minLeft, expiryTime.secLeft);
    } else {
      let countdownMin = 3;
      this.timer = new CountdownTimer(countdownMin, 0);
    }

    this.timer.delegate = this;
    this.timer.start();
  }

  ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }

  ionViewDidEnter() {
    this.setupStripe('card-element');
    this.metaTagService.updateTitle(`Confirm Booking`);
  }

  ionViewWillLeave() {
    if (!this.preventRejectOnLeave) {
      this.timer.pause();
      this.eventService.rejectEventTimeslot();
    }
    this.preventRejectOnLeave = false;
  }

  private setupStripe(cardElementID: string) {
    if (!document.getElementById(cardElementID)) {
      console.log('no card element');
      return;
    }

    let elements = this.stripe.elements();
    var style = {
      base: {
        color: '#25282a',
        lineHeight: '50px',
        fontFamily: '"Fira Sans", Arial, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
          color: '#86878e',
        },
        border: '1px solid grey',
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };

    this.card = elements.create('card', { style: style });

    this.card.mount('#' + cardElementID);

    this.card.addEventListener('change', (event: any) => {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  closeAndReject() {
    this.timer.pause();
    this.preventRejectOnLeave = false;
    this.navCtrl.pop();
  }

  backButtonAction() {
    this.closeAndReject();
  }

  countdownEnded() {
    this.alert.show(
      'Order Canceled',
      'Your reservation time expired and this order has been cancelled.',
      'Ok',
      () => {
        this.closeAndReject();
      },
    );
  }

  // -- Payment options --

  selectedPaymentCardText() {
    if (this.selectedCustomer) {
      return this.paymentCardText(this.userService.user.customer);
    } else {
      return 'No payment selected';
    }
  }

  paymentCardText(customer: any) {
    if (customer.cardBrand) {
      return `${customer.cardBrand} ending *${customer.last4}`;
    } else {
      return `Card ending ${customer.last4}`;
    }
  }

  editPayment() {
    this.paymentPickerOpen = true;
    this.changeRef.detectChanges();
  }

  async selectCustomer(customer: any) {
    this.closePaymentPicker();

    if (this.selectedCustomer.id !== customer.id) {
      // Event doesn't take customerID, so make default the selected customer.
      let loading = await this.loadingCtrl.create();
      loading.present();

      this.paymentService.selectPayment(
        customer.id,
        () => {
          loading.dismiss();
          this.selectedCustomer = customer;
          this.changeRef.detectChanges();
        },
        (errMsg: string) => {
          loading.dismiss();
          this.error(errMsg);
        },
      );
    }
  }

  closePaymentPicker() {
    this.paymentPickerOpen = false;
    this.changeRef.detectChanges();
  }

  addNewPayment() {
    this.closePaymentPicker();
    this.addingNewPayment = true;
    this.changeRef.detectChanges();
    this.setupStripe('card-element');
  }

  returnToCheckout() {
    this.addingNewPayment = false;
    this.changeRef.detectChanges();
  }

  async saveNewPayment() {
    this.addCard(
      () => {
        this.selectedCustomer = this.userService.user.customer;
        this.returnToCheckout();
        this.changeRef.detectChanges();
      },
      (errMsg: string) => {
        this.error(errMsg);
      },
    );
  }

  async addCard(success: () => void, error: (errMsg: string) => void) {
    if (!this.cardFields.cardholderName) {
      this.error('Please enter cardholder name.');
      return;
    }

    let loading = await this.loadingCtrl.create();
    loading.present();

    let data = {
      name: this.cardFields.cardholderName,
    };

    this.stripe.createToken(this.card, data).then((result: any) => {
      if (result.error) {
        var errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
        loading.dismiss();
      } else {
        this.paymentService.createCustomer(
          result.token,
          this.cardFields.cardholderName,

          () => {
            loading.dismiss();
            success();
          },
          (errorMsg: string) => {
            loading.dismiss();
            error(errorMsg);
          },
        );
      }
    });
  }

  customerSelected(customer: any) {
    return this.selectedCustomer && this.selectedCustomer.id == customer.id;
  }

  // -- end payment options --

  confirmPressed() {
    // this.analytics.track(AnalyticsService.ConfirmEventPressed)
    this.timer.pause();

    if (!this.selectedCustomer && this.eventInfo.requiresPayment) {
      this.addCard(
        () => {
          this.reserveAppt();
        },
        (errMsg: string) => {
          this.timer.start();
          this.error(errMsg);
        },
      );
      return;
    }

    this.reserveAppt();
  }

  reserveAppt(shouldCancelUpcomingTimeslot?: boolean) {
    this.timer.pause();

    this.confirming = true;
    this.changeRef.detectChanges();

    this.eventService.signUpForTimeslot(
      this.eventSelectedTimeslot.id,
      this.eventSelectedService.id,
      shouldCancelUpcomingTimeslot,
      () => {
        let analyticsProps: any = {
          type: this.userService.user.currentProType || 'Hair',
          value: this.cost ? this.cost.total : 0,
          currency: this.cost ? this.cost.currency : 'USD',
          revenue: this.cost ? this.cost.total : 0,
        };

        this.analytics.track(
          AnalyticsService.BookingCompleteEvent,
          analyticsProps,
        );

        fbq('track', 'Purchase', {
          currency: this.cost ? this.cost.currency : 'USD',
          value: this.cost ? this.cost.total : 0,
          eventID: this.eventSelectedTimeslot.id,
          event: 'Purchase',
        });

        this.observables.publishBooked();
        this.preventRejectOnLeave = true;
        this.confirmed = true;
        this.changeRef.detectChanges();
      },
      (msg) => {
        this.confirming = false;
        this.changeRef.detectChanges();
        this.timer.start();

        if (
          msg.includes(
            'You have a reservation for another event at this location',
          )
        ) {
          this.tryCancelAndRebook(msg);
        } else {
          this.alert.show('Error', msg);
        }
      },
    );
  }

  async tryCancelAndRebook(msg: string) {
    let splitString = msg.split(', on ');
    let oldTimeslotDateString = '';
    if (splitString.length >= 2) {
      oldTimeslotDateString = splitString[1].split('.')[0];
    }

    let alert = await this.alertCtrl.create({
      header: 'Reschedule existing timeslot?',
      message: `You have an upcoming timeslot at this location (${oldTimeslotDateString}). Do you want to cancel and book the new time instead?`,
      buttons: [
        {
          text: 'Do nothing',
          handler: () => {
            // Nothing
          },
        },
        {
          text: 'Book new time',
          handler: () => {
            let shouldCancelUpcomingTimeslot = true;
            this.reserveAppt(shouldCancelUpcomingTimeslot);
          },
        },
      ],
    });

    alert.present();
  }

  viewUpcoming() {
    this.preventRejectOnLeave = true;
    this.menuCtrl.enable(true);
    this.navCtrl.navigateRoot('/appointments');
  }

  calculateCost() {
    if (!this.eventInfo.requiresPayment) {
      return;
    }

    this.eventService.calculateCost(
      this.eventInfo.id,
      this.eventSelectedService.id,
      (cost) => {
        this.cost = cost;
        this.changeRef.detectChanges();
      },
      (errMsg: string) => {
        this.error(errMsg);
      },
    );
  }

  async viewReceipt() {
    if (!this.cost) {
      this.error('Calculating cost... Please wait a few seconds.');
      return;
    }

    const receiptModal = await this.modalCtrl.create({
      component: EventReceiptPage,
      componentProps: {
        cost: this.cost,
        currency: this.eventInfo.currency,
        serviceTitle: this.eventSelectedService.serviceTitle,
      },
      cssClass: 'auto-height',
    });

    await receiptModal.present();
  }

  async openCalendarPicker() {
    const barberName = this.barber.fullName;
    const startDate = this.eventSelectedTimeslot.startTime;
    const address = this.eventInfo.locationDescription;

    const startString = Moment(startDate).format();
    const endString = Moment(startDate).add(45, 'minutes').format();

    const opts = {
      title: `Shortcut appointment with ${barberName}`,
      location: this.eventInfo.eventLinkURL ?? address, // Zoom link or address
      start: startString,
      end: endString,
    };

    let buttons = [
      {
        text: 'Google Calendar',
        handler: () => {
          window.open(Calendars.getGoogleCalendarUrl(opts), '_blank');
        },
      },
      {
        text: 'iCalendar',
        handler: () => {
          Calendars.downloadIcs(opts);
        },
      },
      {
        text: 'Outlook',
        handler: () => {
          window.open(Calendars.getMicrosoftCalendarUrl(opts), '_blank');
        },
      },
    ];

    let alert = await this.alertCtrl.create({
      header: 'Add To Calendar',
      buttons: buttons,
    });

    alert.present();
  }

  // Helpers

  prettyTime(date: Date) {
    let timezone = {
      offset: this.eventInfo.timezoneOffset,
    };
    return `${Util.prettyTimeAdjusted(date, timezone)} on ${Util.dayMonthDate(
      date,
      timezone,
    )}`;
  }

  roundedRating(n: number) {
    return Math.round(n);
  }

  toRange(n: number) {
    return Util.toRange(n);
  }

  updateTimer() {
    console.log('update timer');
    this.changeRef.detectChanges();
  }

  timerSecLeft(sec: number) {
    if (this.timer.minLeft < 1 && this.timer.secLeft <= sec) {
      return true;
    }
    return false;
  }

  formatCost(num: number, currency: string) {
    return Util.formatCost(num, currency);
  }

  private error(msg: string) {
    this.alert.show('Error', msg);
  }
}
